module.exports = __webpack_public_path__ + "img/shouye-xuqiucee-png.512b3d0d.svg";